import angular from 'angular';
import mainMenuComponent from './main-menu.component';
import MainMenuService from './main-menu.service';
import mainMenuConfig from './main-menu.config';

let mainMenuModule = angular.module('app.mainMenu',[])
  .component('mainMenu', mainMenuComponent)
  .service('MainMenuService', MainMenuService)
  .config(mainMenuConfig);

export default mainMenuModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/main-menu/main-menu.js
 **/